import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientPortalTabContent} from "./ClientPortalTabContent";
import {withRouterParams} from "../../utils/withRouterParams";

class ClientPortalTabPageClass extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <ClientPortalTabContent clientId={this.props.match.params.id}/>
            </div>
        )
    }
}

export const ClientPortalTabPage = withRouterParams(ClientPortalTabPageClass);
export default ClientPortalTabPage;
